// extracted by mini-css-extract-plugin
export default {"switch":"settingsForTable_switch__5kT3e","tableOption":"settingsForTable_tableOption__e-Ks+"};